import { OnInit } from "@angular/core";
var Error404Component = /** @class */ (function () {
    function Error404Component(settings) {
        this.settings = settings;
    }
    Error404Component.prototype.ngOnInit = function () {
    };
    return Error404Component;
}());
export { Error404Component };
